import Header from '../../components/common/header/index.vue'
import Bottom from '../../components/common/bottom/index.vue'
import axios from 'axios'
export default {
  name: 'cultural',
  components: { Header, Bottom },
  data () {
    return {
      isLoading: false,
      // 类别数组
      classList: [],
      // 选中的类别
      selectClass: '',
      // 年代数组
      eraList: [],
      // 选中的年代
      selectEra: '',
      // 数据list
      dataList: [],
      // 用于搜索的类别
      searchClass: '',
      // 用于搜索的年代
      searchEra: '',
      // 搜索关键词
      keyWord: '',
      // 总数
      total: 0,
      pageNo: 1,
      pageSize: 16
    }
  },
  // 创建元素
  mounted () {
    this.getSelect()
    this.getRelics()
  },
  // 方法定义
  methods: {

    // 点击前往首页
    goHome () {
      this.$router.push('/home')
    },

    // 获取下拉数据
    getSelect () {
      const self = this
      axios.get('/juanzonggg/collect/getCollectMHAddDataList').then(json => {
        if (json.data.code === 200) {
          self.classList = json.data.content.collectionClassMatadataList
          self.eraList = json.data.content.eraMetadataVOList
        } else {
          self.$message.warning(json.data.message)
        }
      }).catch(err => {
        console.log(err)
      })
    },

    // 获取精品文物数据
    getRelics () {
      const self = this
      self.isLoading = true
      const data = {
        pageNo: self.pageNo,
        pageSize: self.pageSize,
        searchConditions: self.keyWord.trim(),
        classid: self.searchClass,
        eraid: self.searchEra
      }
      axios.post('/juanzonggg/collect/ListMHCollect', data).then(json => {
        if (json.data.code === 200) {
          self.dataList = json.data.data.rows
          self.total = json.data.data.totalRows
          self.dataList.forEach(item => {
            item.imgUrl = window.location.origin + item.url
          })
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        self.isLoading = false
      })
    },

    handleSearch () {
      this.pageNo = 1
      this.searchClass = this.selectClass
      this.searchEra = this.selectEra
      this.getRelics()
    },

    // 分页器
    handleCurrentChange (current) {
      this.pageNo = current
      this.getRelics()
    },

    // 点击前往详情
    enterDetail (item) {
      // eslint-disable-next-line no-case-declarations
      const culturalDetail = this.$router.resolve({
        path: '/culturalDetail',
        query: {
          id: item.id
        }
      })
      window.open(culturalDetail.href, '_blank')
    }
  }
}
